export default __webpack_public_path__ + "static/media/for-players.acb80df1.webp";